export default {"src":"/_next/static/media/chevron-down-white.4b55dcf4.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};